import { baseApi } from 'api/api-base';
import camelcaseKeys from 'camelcase-keys';
import { API_ROUTES } from 'constants/api-routes';
import {
  DashboardData,
  GetUserCalculations,
  GetUserData,
  UpdateUserData,
  UpdateUserWallet,
} from 'types/api/api-user.types';

import { setCalculations } from 'store/slices/user-slice';

export const userApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getUserData: builder.query<GetUserData.ResponseType, GetUserData.RequestType>({
      query: () => ({
        url: API_ROUTES.GET_USER_DATA,
      }),
      providesTags: ['Account'],
      extraOptions: {},
      transformResponse: (response: GetUserData.RawApiResponse | DashboardData): GetUserData.ResponseType => {
        if ('success' in response && response.success && 'data' in response) {
          return response.data;
        }
        return response as DashboardData;
      },
    }),

    getCalculationsData: builder.query<GetUserCalculations.ResponseType, GetUserCalculations.RequestType>({
      query: ({ userId }) => ({
        url: `${API_ROUTES.GET_USER_DATA}/${userId}/${API_ROUTES.CALCULATIONS}`,
      }),
      extraOptions: {},
      transformResponse: (response: GetUserCalculations.RawApiResponse) => {
        return camelcaseKeys(response as unknown as Record<string, unknown>, {
          deep: true,
        }) as GetUserCalculations.ResponseType;
      },
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setCalculations(data.calculations));
        } catch (error) {
          console.error('Failed to fetch calculations', error);
        }
      },
    }),

    updateUserData: builder.mutation<UpdateUserData.RawApiResponse, UpdateUserData.RequestType>({
      query: body => ({
        method: 'PUT',
        url: `${API_ROUTES.UPDATE_USER_DATA}`,
        body,
      }),
      extraOptions: {},
    }),

    updateUserWallet: builder.mutation<UpdateUserWallet.RawApiResponse, UpdateUserWallet.RequestType>({
      query: body => ({
        method: 'PUT',
        url: `${API_ROUTES.UPDATE_USER_WALLET}`,
        body,
      }),
      extraOptions: {},
    }),
  }),
});

export const {
  useGetUserDataQuery,
  useUpdateUserDataMutation,
  useUpdateUserWalletMutation,
  useGetCalculationsDataQuery,
} = userApi;
